var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9996 9.16669H14C13.9868 12.9428 10.8579 16 7 16C3.13401 16 0 12.93 0 9.14286C0 5.36368 3.12091 2.29856 6.97575 2.28575V3.80958C3.98002 3.82237 1.55556 6.20526 1.55556 9.14286C1.55556 12.0884 3.99312 14.4762 7 14.4762C9.99877 14.4762 12.4313 12.1012 12.4444 9.16669H12.4448C12.4446 9.15878 12.4444 9.15083 12.4444 9.14286C12.4444 8.72207 12.7927 8.38095 13.2222 8.38095C13.6518 8.38095 14 8.72207 14 9.14286C14 9.15083 13.9999 9.15878 13.9996 9.16669ZM7 6.09524V0L10.1111 3.04762L7 6.09524Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.cd37d7345265b0a898b3bd4a7beb3476.svg";
export { ForwardRef as ReactComponent };